module.exports = __webpack_public_path__ + "static/media/logo-addons.3beabe1c.svg";